import DynamicFormFields from './form';
jQuery('html').removeClass('no-js');
jQuery('body').removeClass('loading');
window.MYPRJKT = window.MYPRJKT || {};
// require('./anchor-scrolling') ...
const memberForms = document.querySelectorAll('.member-form');
memberForms.forEach(memberForm => {
    if (!(memberForm instanceof HTMLFormElement))
        return;
    const dynamicForm = new DynamicFormFields(memberForm);
});
